import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import banner from "../../../assests/banner.png";

function Slider() {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <img
        style={{
          width: "100%",
        }}
        src={banner}
        alt="banner"
      />
    </div>
  );
}

export default Slider;
